import { Grid, Dialog, Box, IconButton } from '@mui/material';
import React, { useRef, useEffect } from 'react';
import useCustomLogic from '../../Hooks/UseCustomLogic';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import MultipleColorTextComponent from '../ReusableComponents/MultipleColorTextComponent';

const ChapterDialog = ({ open, onCloseDialog, title, no, children, isWidth }) => {
    const { isXs, isSm } = useCustomLogic();
    const scrollContainerRef = useRef(null);
    let isNotResponsive = !isXs && !isSm;

    useEffect(() => {
        const container = scrollContainerRef.current;
        if (container) {
            container.addEventListener('scroll', smoothScrolling);
            return () => container.removeEventListener('scroll', smoothScrolling);
        }
    }, []);

    const smoothScrolling = (event) => {
        event.preventDefault();
        const { scrollTop } = event.target;
        scrollContainerRef.current.scrollTop = scrollTop;
    };

    return (
        <Dialog
            open={open}
            onClose={onCloseDialog}
            fullScreen={isXs}
            sx={{
                "& .MuiPaper-root": {
                    minWidth: ['', '', isWidth || '70vw', '60vw', '50vw'],
                    borderRadius: (!isXs) && '20px',
                },
                ".scroll-container": {
                    overflowY: "auto",
                    maxHeight: "calc(100vh - 200px)",
                },
                ".scroll-container::-webkit-scrollbar": {
                    display: "none",
                },
            }}
        >
            <Grid container sx={{
                py: '30px', px: [`${isNotResponsive && '0px'} `, "40px", "30px", "30px", "30px"], whiteSpace: (isXs && isSm) && "break-spaces",
                paddingLeft: (isXs && isSm) && "0px", paddingRight: (isXs && isSm) && "40px"
            }}>

                <Grid item lg={12} md={12} xs={12} container justifyContent="center">
                    <MultipleColorTextComponent variant="h2" heading={title} no={no} />
                    <IconButton
                        onClick={onCloseDialog}
                        aria-label={`Close ${title || "dialog"}`}
                        sx={{ position: 'absolute', right: "25px" }}
                    >
                        <HighlightOffIcon fontSize='large' />
                    </IconButton>
                </Grid>

                <Grid item lg={12} md={12} xs={12} mt={3} className="scroll-container" ref={scrollContainerRef}>
                    <Box p={2}>
                        {children}
                    </Box>
                </Grid>
            </Grid>
        </Dialog>
    );
};

export default ChapterDialog;
